import PropTypes from 'prop-types';
import noSummaryAIImage from "../../../../assets/images/ai-summary.svg";

const NoAISummaryAvailableView = ({ localisedValues }) => {
  return (
    <div className="no-session-data custom-scroll-div">
      <div className="no-session-data-in">
        <div className="no-session-data-box">
          <div className="image">
            <img src={noSummaryAIImage} alt="No AI Summary" />
          </div>
          <h4>{localisedValues?.no_summaries_available}</h4>
          <p>{localisedValues?.turn_on_ai_summaries_to_start_capturing_key_moments_from_your_calls}</p>
        </div>
      </div>
    </div>
  );
};

NoAISummaryAvailableView.propTypes = {
  localisedValues: PropTypes.object,
};

export default NoAISummaryAvailableView;
